import type { LeadListItem } from '@wrapforce/shared';

export function formatLeadVehicle(lead: Pick<LeadListItem, 'vehicleYear' | 'vehicleMake' | 'vehicleModel'>): string {
  return [lead.vehicleYear, lead.vehicleMake, lead.vehicleModel].filter(Boolean).join(' ');
}
